import Locale from '@/types/locale';
import { LOCALE } from '@/utils/i18n';

export const getOmniLocale = (code: Locale): string => code.toLowerCase();

export const isValidLocale = (locale: Locale | null | undefined, appLocales: Locale[]): boolean => !!locale && appLocales.includes(locale);

/**
 * Determines the appropriate locale based on a priority fallback chain:
 * 1. Primary locale (if valid)
 * 2. Secondary locale (if valid)
 * 3. First locale in appLocales array
 * 4. Default to LOCALE.EN_CA
 */
export const getValidLocale = (primaryLocale: Locale | null | undefined, secondaryLocale: Locale | null | undefined, appLocales: Locale[]): Locale => {
  if (isValidLocale(primaryLocale, appLocales)) {
    return primaryLocale!;
  }

  if (isValidLocale(secondaryLocale, appLocales)) {
    return secondaryLocale!;
  }

  if (appLocales.length > 0) {
    return appLocales[0];
  }

  return LOCALE.EN_CA;
};
